export default __webpack_public_path__ + "static/typography-ga-metric-text-54286ab4aee3cccf9594a86955627711079421c0d8947503979722105bf25ef9.png";